import React from 'react'

import ReviewsData from "~/data/sidebar/reviews.json"

type Review = typeof ReviewsData["reviews"][0];

const Reviews = ({ block }: {
  block: {
    _template: string
    css_class_name: string
    rows_no: number
    rows: any[]
  }
}) => {
  block.rows = ReviewsData.reviews.map(function(content) {
    // map content to html elements
    return {content}
  }).reduce(function(r: any[], element, index) {
      // create element groups with size 4, result looks like:
      // [[elem1, elem2, elem3], [elem4, elem5, elem6], ...]
      index % 8 === 0 && r.push([]);
      r[r.length - 1].push(element);
      return r;
  }, []).map(function(rowContent) {
      // surround every group with 'row'
      return {rowContent};
  });
  
  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      {(block.rows_no) ? (
        block.rows.filter((i, index) => (index < block.rows_no)).map((row, index) => {
          var review = row.rowContent.map((review: { content: any }, index: number) => {
  
            var stars = []
            for (var i = 0; i < review.content.stars; i++) {
              stars.push(<i key={i} className="fa fa-star"></i>);
            }
  
            return <div key={index} className="card">
              <div className="top">
                <div className="left">
                  {review.content.image && (
                    <img src={review.content.image} alt={review.content.name} title={review.content.name} loading="lazy" />
                  )}
                </div>
                <div className="right">
                  <div className="name">{review.content.name}</div>
                  <div className="date">{review.content.date}</div>
                </div>
              </div>
              <div className="stars">
                {stars}
              </div>
              <h4>{review.content.title}</h4>
              <div className="text-formatted" dangerouslySetInnerHTML={{__html: review.content.text}}></div>
            </div>
          })
  
          return <div key={index} className='reviews-row-wr'><div className="reviews-row">{review}{review}</div></div>
        })
      ) : (
        block.rows.filter((i, index: number) => (index < 2)).map((row, index: number) => {
          var review = row.rowContent.map((review: { content: any }, index: number) => {
  
            var stars = []
            for (var i = 0; i < review.content.stars; i++) {
              stars.push(<i key={i} className="fa fa-star"></i>);
            }
  
            return <div key={index} className="card">
              <div className="top">
                <div className="left">
                  {review.content.image && (
                    <img src={review.content.image.src} alt={review.content.name} title={review.content.name} loading="lazy" />
                  )}
                </div>
                <div className="right">
                  <div className="name">{review.content.name}</div>
                  <div className="date">{review.content.date}</div>
                </div>
              </div>
              <div className="stars">
                {stars}
              </div>
              <h4>{review.content.title}</h4>
              <div className="text-formatted" dangerouslySetInnerHTML={{__html: review.content.text}}></div>
            </div>
          })
  
          return <div key={index} className='reviews-row-wr'><div className="reviews-row">{review}{review}</div></div>
        })
      ) }
      
    </section>
  )
}

export default Reviews
